---
en:
  add_company: Add company
  add_parent_company: Add parent company
  cancel: Cancel
  companies:
    community_access_locked: Community posts are disabled by parent company
    delete_company: Delete company
    errors:
      missing_company: Company must be present for treeview items.
  delete: Delete
  edit: Edit
  external_URLs: External URLs
  kiosk_mode_setup: Kiosk mode setup
  name: Name
  ownership_share: Ownership share
  ownership_share_saves_on_exit: Saves on exit
  ownership_share_unlock: Unlock to edit the ownership share. It saves as soon as you leave the field.
  parent_companies: Parent companies
  parent_company_last_parent_locked: Cannot remove the last parent. To make this company top-level, ask support.
  parent_company_locked: Locked
  portal_config: Portal config
  save: Save
  select_parent_company: Select parent company
  subsidiaries: Subsidiaries
